import { lazy } from 'react';
import { authRoles } from 'app/auth';
import FeatureGuard from 'app/shared-components/FeatureGuard';

const MarketingMaterialPage = lazy(() => import('./MarketingMaterialPage'));

const MarketingMaterialConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
            background: 'featured',
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'marketing-material',
      element: (
        <FeatureGuard flag="marketing_material">
          <MarketingMaterialPage />
        </FeatureGuard>
      ),
    },
  ],
};

export default MarketingMaterialConfig;
